import { observable, action, decorate } from 'mobx';

class SnackbarStore {
  constructor() {
    this.isOpen = false;
    this.duration = 5000;
    this.variant = 'info';
    this.title = '';
    this.messages = [];

    this.close = this.close.bind(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  setError({ title, duration = 5000, messages = [] }) {
    this.setMessage({
      title,
      duration,
      variant: 'error',
      messages,
    });
  }

  setSuccess({ title, duration = 5000, messages = [] }) {
    this.setMessage({
      title,
      duration,
      variant: 'success',
      messages,
    });
  }

  setMessage({
    title,
    duration,
    variant,
    messages,
  }) {
    this.title = title;
    this.duration = duration;
    this.variant = variant;
    this.messages = Array.isArray(messages) ? messages : [];
    this.open();
  }
}

decorate(SnackbarStore, {
  isOpen: observable,
  duration: observable,
  variant: observable,
  title: observable,
  messages: observable,
  open: action,
  close: action,
  setMessage: action,
});

export default SnackbarStore;



// WEBPACK FOOTER //
// ./src/stores/snackbar.js